import { useTranslation } from 'react-i18next'

import { priceShow } from 'shared/lib/priceShow'
import MBonusLine from 'shared/ui/mbonus/mbonus-line/mbonus-line'
import { Paper } from 'shared/ui/paper'

import s from './styles.module.scss'

type Props = {
  price: string | undefined
  count: number

  isMBonus?: boolean
  MBonusCount?: string
}

export const TotalPrice = ({ price, count, isMBonus, MBonusCount }: Props) => {
  const { t } = useTranslation()

  const bonuses = (Number(MBonusCount) * count).toString()
  return (
    <Paper>
      <div className={s.total}>
        <div className={s.flexxer}>
          <h4 className="bold-16">{t('excursions.price_to_pay')}</h4>
          <h4 className="bold-16">
            {priceShow((Number(price) * count).toString())} &#8384;
          </h4>
        </div>

        <div className={s.flexxer}>
          <h4 className="regular-14">{t('excursions.for_one_person')}</h4>
          <h4 className="regular-14">{priceShow(price)} &#8384;</h4>
        </div>

        {isMBonus && (
          <div className="MBonus">
            <MBonusLine price={bonuses} />
          </div>
        )}
      </div>
    </Paper>
  )
}
